module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHVJREFUeNpiYCAAwsLCGkAYnxpGAgYEAKn1UG7gqlWrNpBkCNAAAyC1H4gFoEIfgNgRaNAFogwBGiAANcAATeoC1KAPyIJMOBwyH4sBDFCx+eiCzNgCEkhl4AkqDW1tbcarV68egAmw4FDYyDAKRsGwBQABBgDruhwDZ3Cn4QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/~/syncfusion-javascript/Content/ej/web/common-images/reports/up.png
// module id = ../../../../syncfusion-javascript/Content/ej/web/common-images/reports/up.png
// module chunks = 2